<h2 mat-dialog-title>Back to Login</h2>
<mat-dialog-content>Are you sure you want to be logged out?</mat-dialog-content>
<mat-dialog-actions>
  <button class="btn btn-red" mat-button (click)="confirmAndLogout()">Yes, log me out</button>
  <button class="btn" mat-raised-button (click)="cancelAndStay()">No, I want to stay</button>
</mat-dialog-actions>